<template>
    <div class="error-page">
        <h1>Page not found</h1>
        <p>The page you're looking for doesn't exist or may have been moved.</p>
        <div class="error-page-actions">
            <router-link :to="homeLink.to">
                <Bttn>{{ homeLink.label }}</Bttn>
            </router-link>
            <Bttn class="outlined" @click="$router.back()">Go back</Bttn>
        </div>
    </div>
</template>

<script>
import { useUserStore } from "js/stores/userStore";

export default {
    name: "NotFound",
    computed: {
        homeLink() {
            return useUserStore().isLoggedIn
                ? { to: "/", label: "Go home" }
                : { to: "/login", label: "Log in" };
        },
    },
};
</script>
